/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExcelPlantillaCasualPersonnelGet$Params {
  plantilla_ids?: Array<string>;
}

export function apiExcelExcelPlantillaCasualPersonnelGet(http: HttpClient, rootUrl: string, params?: ApiExcelExcelPlantillaCasualPersonnelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExcelPlantillaCasualPersonnelGet.PATH, 'get');
  if (params) {
    rb.query('plantilla_ids', params.plantilla_ids, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExcelPlantillaCasualPersonnelGet.PATH = '/api/Excel/Excel_PlantillaCasualPersonnel';
